import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import { DatePickerCustomHeader } from './datePickerCustomHeader';
import './css/customDatePicker.css';


export const CustomDatePicker = ({...props}:ReactDatePickerProps) => {
  return (
    <DatePicker
      {...props}
      calendarClassName={`customDatePickerCalendar ${props.calendarClassName || ''}`}
      renderCustomHeader={DatePickerCustomHeader}
      fixedHeight
    />
  );
}